import { MediaType } from '@web/gql/graphql'
import nClicks from '@web/libs/nlog/click/codes'

import { MediaListNClickArea } from './index.interface'

export const getNClickCode = (type: MediaType, nClickArea: MediaListNClickArea) =>
  type === MediaType.Image ? nClicks[nClickArea].PHOTO : nClicks[nClickArea].VIDEO
